module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-05.acb19784.svg";